import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HomeService from "../../Services/HomeService";

//Fetch All
export const fetchRemarksOnProperty = createAsyncThunk(
  "Data/AllRemarks",
  async () => {
    console.log("FF07", "Hello");
    // const response = await HttpClientXml.requestData("feedback", "GET", {});
    const response = await HomeService.getRemarksOnProperties();
    console.log("FF10", response);

    return response.data;
  }
);

// const initialState = {
//     isOpen: false,
//     status:"pending",
//     unreadRemarks: []
// }

const Sidebarslices = createSlice({
  name: "sidebar",
  initialState: {
    isOpen: false,
    unreadRemarks: [],
    status: "",
  },
  reducers: {
    openSidebar(state, action) {
      state.isOpen = true;
    },
    closeSidebar(state, action) {
      state.isOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Remarks
      .addCase(fetchRemarksOnProperty.pending, (state) => {
        state.status = "reading";
      })
      .addCase(fetchRemarksOnProperty.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.unreadRemarks = action?.payload?.filter(
          (item) => !item.readByAdmin
        );
      })
      .addCase(fetchRemarksOnProperty.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});
export default Sidebarslices.reducer;
export const { openSidebar, closeSidebar } = Sidebarslices.actions;
